import axios from "axios";

/**
 * Producción:
 *   REACT_APP_API_URL=https://tu-backend.onrender.com/api
 *
 * Desarrollo local:
 *   REACT_APP_API_URL_LOCAL=http://localhost:4001/api
 *
 * También permite usar REACT_APP_API_URL durante el desarrollo
 * cuando se quiere conectar el frontend local al backend desplegado.
 */
const rawBaseURL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL || "/api"
    : process.env.REACT_APP_API_URL_LOCAL ||
      process.env.REACT_APP_API_URL ||
      "http://localhost:4001/api";

const baseURL = String(rawBaseURL).replace(/\/+$/, "");

const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 20000,
});

/**
 * Compatibilidad con los módulos antiguos que preparan el body
 * utilizando JSON.stringify().
 *
 * No establece Content-Type manualmente cuando el body es FormData,
 * para que el navegador agregue correctamente el boundary.
 */
api.interceptors.request.use(
  (config) => {
    const data = config.data;

    if (typeof data === "string") {
      const value = data.trim();

      const appearsToBeJson =
        (value.startsWith("{") && value.endsWith("}")) ||
        (value.startsWith("[") && value.endsWith("]"));

      if (appearsToBeJson) {
        if (typeof config.headers?.set === "function") {
          config.headers.set("Content-Type", "application/json");
        } else {
          config.headers = {
            ...(config.headers || {}),
            "Content-Type": "application/json",
          };
        }
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Error de conexión con el servidor";

    if (process.env.NODE_ENV !== "production") {
      console.error("[API ERROR]", {
        baseURL,
        url: error?.config?.url,
        method: error?.config?.method,
        status,
        message,
      });
    }

    return Promise.reject(error);
  },
);

/**
 * Export nombrado requerido por src/api/client.js.
 */
export function getAxiosBaseUrl() {
  return api.defaults.baseURL || baseURL;
}

export default api;
